// eslint-disable-next-line vue/no-multiple-template-root
<template>
  <div
    ref="side_panel"
    :class="['side-panel', 'shadow-lvl-2', panelMode ? 'active' : '']"
    v-loading="loading"
  >
    <component :is="`style`">
      .side-panel { right: -{{ panelWidth }}px; }
    </component>
    <VacanciesTab
      v-if="panelMode == 'candidatePanel' || panelMode == 'canditateStagePanel'"
    />
    <PanelCandidatesTab
      v-if="panelMode == 'vacancyPanel' || panelMode == 'vacancyStagePanel'"
    />
  </div>
</template>

<script>
import { store } from '@/store';
import VacanciesTab from 'Elements/Tab/VacanciesTab';
import PanelCandidatesTab from '../Tab/PanelCandidatesTab.vue';
export default {
  mounted() {
    this.observer = new ResizeObserver(entries => {
      this.panelWidth = entries[0].target.offsetWidth;
    });
    this.observer.observe(this.$refs.side_panel);
  },
  components: { VacanciesTab, PanelCandidatesTab },
  data() {
    return {
      panelWidth: 0,
      observer: null
    };
  },
  computed: {
    panelMode() {
      const mode = store.state.rightPanel.panelMode;
      if (!mode && store.state.rightPanel.candidateTabOnceOpened) {
        store.commit('rightPanel/setParam', {
          name: 'candidateTabOnceOpened',
          val: false
        });
      }
      return mode;
    },
    loading() {
      return store.state.rightPanel.loading;
    }
  },
  methods: {
    setPanelParam(paramName, paramValue) {
      return store.commit('rightPanel/setParam', {
        name: paramName,
        val: paramValue
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.side-panel {
  position: fixed;
  top: 0;
  bottom: 0;
  background-color: $white;
  height: 100vh;
  z-index: 1001;
  overflow: hidden;
  min-width: 320px;

  &.active {
    right: 0;
  }
}
</style>
